<template>
  <div class="tile">
    <p class="text__center text__bold">Manager</p>
    <p v-if="!manager" class="lender--placeholder flex__center">No manager selected for this user</p>
    <div v-else class="lender--content">
      <div class="flex__center mb-15">
        <div class="lender--headshot">
          <img
            v-if="manager.headshot"
            :src="manager.headshot"
            :alt="`${manager.name.first}'s headshot`"
          />
          <span v-else class="flex__center default__avatar">{{ defaultAvatar }}</span>
        </div>
        <h3 class="text__bold">
          <span>{{ manager.name.first }}</span>
          <br />
          <span>{{ manager.name.last }}</span>
        </h3>
      </div>
      <div>
        <div>
          <p class="flex__between tile--row">
            <span class="text__bold">Email:</span>
            <a :href="`mailto: ${primaryEmail}`">{{ primaryEmail }}</a>
          </p>
          <p class="flex__between tile--row" v-if="manager.contact_info">
            <span class="text__bold">Phone:</span>
            <span>{{ manager.contact_info.phone ? manager.contact_info.phone : "none" }}</span>
          </p>
          <p class="flex__between tile--row" v-if="manager.contact_info">
            <span class="text__bold">Mobile:</span>
            <span>{{ manager.contact_info.mobile ? manager.contact_info.mobile : "none" }}</span>
          </p>
          <p class="flex__between tile--row" v-if="manager.contact_info">
            <span class="text__bold">Fax:</span>
            <span>{{ manager.contact_info.fax ? manager.contact_info.fax : "none" }}</span>
          </p>
        </div>
        <p class="flex__between tile--row align__start" v-if="manager.address">
          <span class="text__bold">Address:</span>
          <span class="text__right">
            {{ manager.address.street }}
            <br />
            {{ manager.address.city }}, {{ manager.address.state }}
            <br />
            {{ manager.address.zip }}
          </span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["manager"],
  computed: {
    defaultAvatar() {
      const names = this.manager.display_name.split(" ");
      const first = names[0].split("")[0].toUpperCase();
      const last = names[names.length - 1].split("")[0].toUpperCase();
      return `${first} ${last}`;
    },
    primaryEmail() {
      if (!this.manager.new_email || this.manager.new_email.length === 0) {
        return this.manager.email;
      } else {
        const primary = this.manager.new_email
          .filter(email => {
            return email.primary;
          })
          .shift();
        return primary.email;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.lender--headshot {
  margin: 0;
  margin-right: 10px;
}
</style>